import api from '@/api'
import Vue from "vue";

export default {
  state: {
    organizations: {},
    organizationUsers: {},
    organizationBidRules: {},
    organizationAdditionalBidRules: {}
  },

  getters: {
    organization: s => orgId => s.organizations[orgId],
    organizationUsers: (s, getters) => orgId => (s.organizationUsers[orgId] || []).map(id => getters.user(id)),
    organizationBidRules: s => s.organizationBidRules,
    organizationAdditionalBidRules: s => s.organizationAdditionalBidRules
  },

  mutations: {
    setOrganization(s, organization) {
      const model = {
        id: organization.id,
        type: new api.OrganizationType(organization.type),
        isResident: !!organization.resident,
        resident: !!organization.resident ? 'resident' : 'non-resident',
        shortName: organization.shortName,
        fullName: organization.fullName,
        inn: organization.uid,
        users: []
      };

      if (organization.bossFirstName || organization.bossLastName || organization.bossMiddleName) {
        model.boss = {
          firstName: organization.bossFirstName,
          lastName: organization.bossLastName,
          middleName: organization.bossMiddleName
        };
      }

      if (organization.accountantOut !== undefined || organization.accountantFirstName || organization.accountantLastName || organization.accountantMiddleName) {
        model.accountant = {
          firstName: organization.accountantFirstName,
          lastName: organization.accountantLastName,
          middleName: organization.accountantMiddleName,
          accountantOut: !!organization.accountantOut
        };
      }

      Vue.set(s.organizations, model.id, model);
    },

    updateOrganizationUsers(s, {organizationId, users}) {
      console.log(`update users for org ${organizationId}: ${users}`)
      Vue.set(s.organizationUsers, organizationId, users);
    },

    setOrganizationBidRules(s, rules) {
      s.organizationBidRules = rules;
    },

    setOrganizationAdditionalBidRules(s, rules) {
      s.organizationAdditionalBidRules = rules;
    }
  },

  actions: {
    async saveOrganization({dispatch}, {id, type, resident, shortName, fullName, inn, boss, accountant}) {
      let outType = (new api.OrganizationType(type)).valueOf();

      try {
        const response = await api.put(`/organization/${id}`, {
          type: outType,
          resident: resident === 'resident',
          shortName,
          fullName,
          uid: inn,
          boss: boss,
          accountant: accountant
        });
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          await dispatch('handleProfile', {profile: result, currentUser: true});
        }
        else {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        console.error('Something went wrong while saving organization data', e);
        throw e;
      }
    },

    async sendInvite({}, {email, role}) {
      try {
        const response = await api.post(`/account/invite`, {
          email,
          commission: role === undefined ? undefined : role === 'commission'
        });
        const { status, errorCode } = response.data;

        if (status !== 200) {
          throw new api.Errors(errorCode);
        }
      }
      catch(e) {
        throw e;
      }
    },

    async fetchOrganizationUsers({commit, dispatch}, {organizationId}) {
      const errors = {
        Unknown: 'error.unknown',
        NotFilled: 'error.not-filled',
        Denied: 'error.denied',
        LoginBusy: 'error.login-busy'
      };

      try {
        const response = await api.get(`/organization/users/${organizationId}`);
        const { status, result, errorCode } = response.data;

        if (status == 200) {
          const users = result.map(r => {
            dispatch('handleProfile', {profile: r});
            return r.id;
          });

          commit('updateOrganizationUsers', {
            organizationId,
            users
          });
        } else {
          let error = errors[errorCode] || 'error.unknown';
          console.error(errorCode);
          throw error;
        }
      }
      catch(e) {

      }
    },

    async changeMainUserFlag({commit, dispatch, getters}, {userId, organizationId}) {
      try {
        const response = await api.post(`organization/assignMain/${userId}`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          const users = result.users.map(r => {
            dispatch('handleProfile', {
              profile: r,
              currentUser: r.id === getters.currentUser.id
            });
            return r.id;
          });

          dispatch('handleProfile', { profile: result.user, currentUser: result.user.id === getters.currentUser.id});

          commit('updateOrganizationUsers', {
            organizationId,
            users
          });
        } else {
          throw new api.Errors(errorCode);
        }
      }
      catch (e) {

      }
    },

    async changeCommissionMemberFlag({dispatch}, {userId, organizationId, flag}) {
      try {
        const response = await api.post(`account/setCommission/${userId}/${!!flag}`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          dispatch('handleProfile', { profile: result });
        } else {
          throw new api.Errors(errorCode);
        }
      }
      catch (e) {

      }
    },

    async markOrgAsMainOrganizer({dispatch}, {userId}) {
      let error;

      try {
        const response = await api.put(`account/${userId}/setMainOrganizer`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          dispatch('handleProfile', { profile: result });
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch (e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async changeMainReviewFlag({dispatch, getters}, {userId, organizationId, flag}) {
      try {
        const response = await api.post(`organization/manualReview/${userId}/${!!flag}`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          dispatch('handleProfile', { profile: result, currentUser: result.id === getters.currentUser.id });
        } else {
          throw new api.Errors(errorCode);
        }
      }
      catch (e) {

      }
    },

    async fetchOrganizers({}) {
      try {
        const response = await api.get(`organization/organizers`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          return result;
        } else {
          throw new api.Errors(errorCode);
        }
      }
      catch (e) {
      }
    },

    async fetchOrganizationBidRules({commit}) {
      let error;

      try {
        const response = await api.get(`/organization/bidRules`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          commit('setOrganizationBidRules', result);
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch (e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async fetchOrganizationAdditionalBidRules({commit}) {
      let error;

      try {
        const response = await api.get(`/organization/additionalBidRules`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          commit('setOrganizationAdditionalBidRules', result);
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch (e) {
        error = e;
      }

      if (error) {
        throw error;
      }
    }
  }
}
